import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/code/medal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-medal-index" */ '~/pages/r_code/Medal/pages/index'
        )
    ),
  },
  // 标题勋章
  {
    path: '/code/titleMedal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-MedalTitle-index" */ '~/pages/r_code/MedalTitle/pages/index'
        )
    ),
  },
  // 标题勋章 详情
  {
    path: '/code/titleMedal/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-MedalTitle-index-Details" */ '~/pages/r_code/MedalTitle/pages/index/Details'
        )
    ),
  },
] as RouteConfig[]
